export const colorFromSession = session => {
  if (!session || !session.productCompatibility) {
    return "text-cut2dDesktop";
  }
  const firstSession = session.productCompatibility[0];
  if (!firstSession) {
    return "text-cut2dDesktop";
  }
  let productName = firstSession.productName;
  switch (productName) {
    case "Aspire":
      return "text-aspire";
    case "VCarve Pro":
      return "text-vcarvePro";
    case "VCarve Desktop":
      return "text-vcarveDesktop";
    case "Cut2D Pro":
      return "text-cut2dPro";
    case "Cut2D Desktop":
      return "text-cut2dDesktop";
    default: {
      return "text-cut2dDesktop";
    }
  }
};
